import { getPlaygroundIdCookie } from '@basehub/data/replicache/playground/utils'
import * as React from 'react'

/**
 * Retrieves the playground id from the cookie storage
 * @returns {string} - The playgroundId
 */
export const usePlaygroundCookie = () => {
  const cookie = getPlaygroundIdCookie()
  const [playgroundId, setPlaygroundId] = React.useState<string | undefined>(
    cookie === 'undefined' ? undefined : cookie
  )

  React.useEffect(() => {
    setPlaygroundId(getPlaygroundIdCookie())
  }, [])

  return playgroundId
}
